module.exports = __webpack_public_path__ + "static/bagichi-28e500707e04ed52c932759d35f9d4db.jpg";